import { observer } from "mobx-react-lite";

import React from 'react';
import { Image, List, Popup } from 'semantic-ui-react';
import { Profile } from "../../../app/models/Profile";
import { Link } from "react-router-dom";
import ProfileCard from "../../profiles/ProfileCard";

interface Props{

    participants:Profile[];

}

export default observer(function GameListItemParticipant({participants}:Props) {

    const styles={
        borderColor:'#21BA45',
        borderWidth:4
    }

    return (
        <List horizontal>
            {participants.map(participant=>(
                
                    <Popup hoverable key={participant.userID}
                        trigger = {
                            <List.Item key={participant.userID} as={Link} to={`/profiles/${participant.userID}`}>
                                <Image
                                     size = 'mini' 
                                     circular src = {participant.image || 'assets/user.png'} 
                                     bordered
                                     style={participant.following? styles : null}
                                     />
                                 </List.Item>
                        }                       
                    >
                    <Popup.Content>
                        <ProfileCard profile={participant} />
                    </Popup.Content>
                    </Popup>            
            ))}           
        </List>
    );
});